import React, { useState } from "react";
import CaseStudiesSidebar from "./CaseStudiesSidebar";
import Lightbox from "react-18-image-lightbox";

const CaseStudiesDetailsContent = ({ data }) => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const images = data?.frontmatter?.images;

  const closeLightbox = () => setIsOpen(false);

  const moveToPrev = () =>
    setPhotoIndex((photoIndex + images.length - 1) % images.length);

  const moveToNext = () => setPhotoIndex((photoIndex + 1) % images.length);

  return (
    <>
      <section className="case-studies-details-area ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div
                className="case-studies-details-image gallery-img"
                onClick={() => {
                  setPhotoIndex(0);
                  setIsOpen(true);
                }}
              >
                <img
                  style={{ cursor: "zoom-in" }}
                  src={`${data?.frontmatter?.bannerimage}`}
                  alt="about"
                />
              </div>
              <div className="case-studies-details-desc">
                <span className="sub-title">
                  {data?.frontmatter?.shorttitle}
                </span>
                <h3>{data?.frontmatter?.title}</h3>
                <p>
                  Improve Machine Learning algorithms by studying underfitting,
                  overfitting, training, validation, n-fold cross validation,
                  testing, and how hyperparameters could improve performance.
                  Perform linear and logistic regressions in Python.
                </p>
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                    <div className="content">
                      <h3>Features</h3>
                      <ul>
                        {data?.frontmatter?.features?.map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                    <div className="content">
                      <h3>Tech Stack Used</h3>
                      <ul>
                        {data?.frontmatter?.techStack?.map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <CaseStudiesSidebar data={data} />
            </div>
          </div>
        </div>

        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={closeLightbox}
            onMovePrevRequest={moveToPrev}
            onMoveNextRequest={moveToNext}
          />
        )}
      </section>
    </>
  );
};

export default CaseStudiesDetailsContent;
